import InsideMigration from './InsideMigration'
export default InsideMigration
